export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_04.5e37234a.png";